/**
 * Auth API — login, refresh, logout, me
 */
import api, { setToken, clearToken, setUser } from './client'

export async function login(email, password) {
  const resp = await api.post('/auth/login', { email, password })
  if (resp.success) {
    setToken(resp.accessToken)
    if (resp.user) setUser(resp.user)
  }
  return resp
}

export async function refresh() {
  try {
    const resp = await api.post('/auth/refresh')
    if (resp.success) {
      setToken(resp.accessToken)
      if (resp.user) setUser(resp.user)
    }
    return resp
  } catch (err) {
    clearToken()
    return { success: false }
  }
}

export async function logout() {
  try {
    await api.post('/auth/logout')
  } finally {
    clearToken()
  }
}

export async function getMe() {
  return api.get('/auth/me')
}

export function changePassword(data) {
  return api.put('/auth/change-password', data)
}
